import { render, staticRenderFns } from "./AllianzForwardingChecklist.vue?vue&type=template&id=a8429d1a&scoped=true&"
import script from "./AllianzForwardingChecklist.vue?vue&type=script&lang=js&"
export * from "./AllianzForwardingChecklist.vue?vue&type=script&lang=js&"
import style0 from "./AllianzForwardingChecklist.vue?vue&type=style&index=0&id=a8429d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8429d1a",
  null
  
)

export default component.exports